module.exports = __webpack_public_path__ + "img/red-pad.b2f64be4.png";